module.exports = __webpack_public_path__ + "img/7.838b3875.jpg";